/* eslint-disable no-fallthrough */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Form, Col, Row, Table, SplitButton, ButtonGroup, DropdownButton, ToastContainer, Spinner } from 'react-bootstrap';


import { ArticleService } from '../../../services/ArticleService';
import { EditionService } from '../../../services/EditionService';

import DynamicTable from '../../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../../components/pagination/Pagination';
import SideDetails from '../../../components/side-details/SideDetails';
import ClientDetails from '../../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../../components/families/Families';
import { PreferenceService } from '../../../services/PreferenceService';
import ConfirmDialog from '../../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../../helper/Helper'


const TaxesTpl = (props) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);
    const data = props?.data?.data

    return (
        <Row>
            <Col>
                {data &&
                    <>
                        {data?.details?.map((detail, i) => (
                            <>

                                {props?.currentEdition?.params.find((p) => p.name == "globaliser")?.value ?
                                    <div key={i}>
                                        {detail?.statuts.map((statut, j) => (
                                            <div key={j}>
                                                <h6>{statut?.total?.Libellé} {/* ({statut?.total['Nombre']}) */}</h6>
                                                <Table size="sm" className="mb-5">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-uppercase small text-gray-500">Libellé</th>
                                                            <th className="text-end text-uppercase small text-gray-500">Montant HT</th>
                                                            <th className="text-end text-uppercase small text-gray-500">Montant taxe</th>
                                                            <th className="text-end text-uppercase small text-gray-500">Montant TTC</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className="">{statut?.total["titre"]}</td>
                                                            <td className="text-end">{statut?.total["Montant HT"]}</td>
                                                            <td className="text-end">{statut?.total["Montant taxe"]}</td>
                                                            <td className="text-end">{statut?.total["Montant TTC"]}</td>
                                                        </tr>
                                                        {/* <tr className="fw-bold">
                                                            <td className="bg-primary-100" colSpan="5">{statut.total['formulaLine']}</td>
                                                        </tr> */}
                                                    </tbody>
                                                </Table >
                                            </div>
                                        ))}
                                    </div>
                                    :
                                    <div key={i}>
                                        {detail?.statuts.map((statut, j) => (
                                            <div key={j}>
                                                <h6>{statut?.total?.Libellé} {/* ({statut?.total['Nombre']}) */}</h6>
                                                {statut?.factures?.length > 0 &&
                                                    <Table size="sm" className="mb-5">
                                                        <thead>
                                                            <tr>
                                                                <th className="text-uppercase small text-gray-500">Code</th>
                                                                <th className="text-uppercase small text-gray-500">Désignation</th>
                                                                <th className="text-end text-uppercase small text-gray-500">MOY</th>
                                                                <th className="text-end text-uppercase small text-gray-500">Qte</th>
                                                                <th className="text-end text-uppercase small text-gray-500">PVTE.TOT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {statut?.factures?.map((facture, k) => (
                                                                <tr key={k}>
                                                                    <td className="">{facture['CODE']}</td>
                                                                    <td className="">{facture['DESIGNATION']}</td>
                                                                    <td className="text-end">{facture['PVTE_MOY']}</td>
                                                                    <td className="text-end">{facture['QTE']}</td>
                                                                    <td className="text-end">{facture['PVTE_TOT']}</td>

                                                                </tr>
                                                            ))}
                                                            <tr className="fw-bold">
                                                                <td className="bg-primary-100" colSpan="5">{statut.total['formulaLine']}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table >
                                                }

                                            </div>
                                        ))}
                                    </div>
                                }

                            </>

                        ))}

                        {data?.details.length > 0 &&
                            <>
                                <h6>Récapitulatif</h6>
                                <Table size="sm" className="mb-5">
                                    <thead>
                                        <tr>
                                            <th className="text-uppercase small text-gray-500">Libellé taxe</th>
                                            <th className="text-uppercase small text-gray-500 text-end">Taux</th>
                                            <th className="text-uppercase small text-gray-500 text-end">Nb factures</th>
                                            <th className="text-uppercase small text-gray-500 text-end">Montant HT</th>
                                            <th className="text-uppercase small text-gray-500 text-end">Montant taxe</th>
                                            <th className="text-uppercase small text-gray-500 text-end">Montant TTC</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.recapitulatif?.map((recap, i) => (
                                            <tr key={i}>
                                                <td className="fw-bold">{recap['Libellé taxe']}</td>
                                                <td className="text-end fw-bold">{recap['Taux']}</td>
                                                <td className="text-end fw-bold">{recap['Nb factures']}</td>
                                                <td className="text-end fw-bold">{recap['Montant HT']}</td>
                                                <td className="text-end fw-bold">{recap['Montant taxe']}</td>
                                                <td className="text-end fw-bold">{recap['Montant TTC']}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>
                        }

                        {data?.resume?.map((res, i) => (
                            <div className="bg-primary-100 p-3 border rounded mb-3" key={i}>
                                {res['Nombre de Factures'] !== undefined && <p className="m-0">Nombre de Factures : {res['Nombre de Factures']}</p>}
                                {res['Moyenne Net HT par Factures'] !== undefined && <p className="m-0">Moyenne Net HT par Factures : {res['Moyenne Net HT par Factures']}</p>}
                                {res['Nombre de lignes'] !== undefined && <p className="m-0">Nombre de lignes : {res['Nombre de lignes']}</p>}
                                {res['Moyenne par ligne'] !== undefined && <p className="m-0">Moyenne par ligne : {res['Moyenne par ligne']}</p>}
                            </div>
                        ))}

                    </>
                }
                {(data?.details.length === 0 && data?.recapitulatif.length === 0 && data?.resume.length === 0) &&
                    <em>- Aucun résultat -</em>
                }
            </Col>
        </Row >
    )
}

export default TaxesTpl;